<div class="modal-container d-flex flex-column h-100">
  <div class="modal-header border-0">
    <h1 class="modal-title text-primary-color">
      {{ titleName }} {{this.enumPopUpTitles.ACTIVITY}}
    </h1>
  </div> 
  <div class="modal-body flex-grow-1 overflow-y-auto overflow-x-hidden">
    <div class="row row-gap-3">
      <div class="col-12 col-sm-6 file-div-wrap">
        <app-dropdown
          [selectLabel]="'Type'"
          [data]="activityPopupTypesList"
          [selectValue]="insertUpdateToDoActivity?.typeId"
          (selectValueEmit)="insertUpdateToDoActivity.typeId = $event"
          [ngClass]="{'border-red':!insertUpdateToDoActivity.typeId && submit}"
          [required]="true"
        >
        </app-dropdown>
      </div>
      <div class="col-12 col-sm-6 file-div-wrap">
        <app-dropdown
          [selectLabel]="'Assigned To'"
          [data]="activityAssigneeList"
          [selectValue]="insertUpdateToDoActivity.assignedToUserId"
          (selectValueEmit)="insertUpdateToDoActivity.assignedToUserId = $event"
          [ngClass]="{'border-red':!insertUpdateToDoActivity.assignedToUserId && submit}"
          [required]="true"
        >
        </app-dropdown>
      </div>
    </div>
    <div class="row m-t-15">
      <div class="col-12">
        <app-input
          [inputLabel]="'Title'"
          [inputType]="'text'"
          [inputValue]="insertUpdateToDoActivity.title"
          (inputValueEmit)="insertUpdateToDoActivity.title = $event"
          [inputReqValidation]="true"
          [ngClass]="{'border-red':!insertUpdateToDoActivity.title && submit}"
        >
        </app-input>
      </div>
    </div>

    <div class="row m-t-15">
      <div class="col-12">
        <app-textarea 
        [label]="'Description'"
        [isRequired]="true"
        [textareaHeight]="'10.6rem'"
        [name]="'notes'"
        [id]="'notes'"
        [inputValue]="insertUpdateToDoActivity.description"
        (inputValueEmit)="insertUpdateToDoActivity.description=$event"
        [textareaClass]="{'bordered-red':!insertUpdateToDoActivity.description && submit}"
        ></app-textarea>
      </div>
    </div>

    <div class="row m-t-15">
      <div class="col">
        <div class="row company-header">
          <div class="col-12 company-name">
            <app-dropdown
              [selectLabel]="'Company'"
              [data]="companyNameList"
              [disabled]="disabledCompany ==true  ? true : false"
              [selectValue]="insertUpdateToDoActivity.companyId"
              (selectValueEmit)="insertUpdateToDoActivity.companyId = $event;selectValueChange(insertUpdateToDoActivity.companyId)"
              [required]="false">
            </app-dropdown>
          </div>
        </div>
        <div class="row m-t-15">
          <div class="col-12">
            <app-dropdown
              [selectLabel]="'Contact'"
              [data]="contactList"
              [disabled]="disabledContact == true ? true : false"
              [selectValue]="insertUpdateToDoActivity.contactId"
              (selectValueEmit)="insertUpdateToDoActivity.contactId = $event;selectContactValueChange(insertUpdateToDoActivity.contactId)"
            >
            </app-dropdown>
          </div>
        </div>
        <div class="row m-t-15">
          <div class="col-12">
            <app-date-picker
              [time]="false"
              [inputReqValidation]="true"
              [inputLabel]="'Due Date'"
              [inputValue]="dueDate"
              (inputValueEmit)="dueDate = $event"
              [ngClass]="{'border-red':!dueDate && submit}"
              [adjustPopupPosition]="'top-right'"
              
            ></app-date-picker>
          </div>
        </div>
        <div class="row m-t-15">
          <div class="col-12">
            <app-ngb-timepicker
            [label]="'Time Due'"
            [id]="'timeDue'"
            [name]="'timeDue'"
            [selectedTime]="insertUpdateToDoActivity.dueTime"
            [ngbTimePickerValue]="ngbTimePickerValue"
            (timeChange)="insertUpdateToDoActivity.dueTime = $event;onTimeChange($event)"
            ></app-ngb-timepicker>
          </div>
        </div>
        <!-- <div class="row m-t-15">
          <div class="col"> -->
            <!-- <app-timepicker
              [inputValue]="insertUpdateToDoActivity.dueTime"
              (inputValueEmit)="insertUpdateToDoActivity.dueTime = $event"
            ></app-timepicker> -->
            <!-- [ngClass]="{'invalide-border':!insertUpdateToDoActivity.dueTime && submit}"
            [inputReqValidation]="true"
             -->
             <!-- <div #clockElement class="">
              <div class="date-container form-floating  d-flex">
                <input
                  [(ngModel)]="selectedTimeValue"
                  readonly
                  class="px-1 hand form-control time-input"
                />
                <label
                for="time"
                class="label1"
                [ngClass]="{'label2' : selectedTime != '' && hideIcon == false}">
                 Time 
                <i class="fst-normal ps-1 p-0 text-danger"></i>
              </label>
                <img width="14px" src="../../../assets/SVGIcons/clockIcon.svg"  (click)="togglePopover()" alt="" class="hand clock">
              </div>
              <span
              [ngClass]="{'d-none': hideIcon == true ||  selectedTime == ''}"
              (click)="clearTime(); "
              class="refresh-icon"><app-svg-icon
                class="svgIcon"
                [src]="'../../../../assets/SVGIcons/undoSVG.svg'"
              ></app-svg-icon
            ></span>
              <ng-container *ngIf="isPopoverOpen" id="isPopoverOpen">
                <ngb-popover placement="bottom" [autoClose]="false">
                  <ngb-timepicker 
                   [id]="'timePicker1'" 
                   [name]="'timePicker1'" 
                   [(ngModel)]="ngbTimePickerValue"
                   (ngModelChange)="changeTimeExpiration($event)"
                   [meridian]="true" class="time-picker-custom timepicker"></ngb-timepicker>
                </ngb-popover>
              </ng-container>
            </div>

          </div>
        </div> -->
      </div>
      <div class="col-12 col-md-6 p-l-15">
        <div class="ms-md-3 mt-2 mt-md-0">
          <label for="" class="text-light-info secondary-text">
            Priority:
            <span class="required-feild mb-1">*</span>
          </label>
          <div
            class="radio radio-p padding-7"
            *ngFor="let saleItem of priorityList; let i = index"
          >
            <input
              type="radio"
              name="radiogroup"
              [value]="saleItem.id"
              [(ngModel)]="insertUpdateToDoActivity.priorityId"
              required
              [id]="'priority' + saleItem.id"
            />
            <label
              for="{{ 'priority' + saleItem.id }}"
              class="form-check-label secondary-text"
            >
              {{ saleItem.name }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0">
    <div class="d-flex flex-wrap justify-content-end m-0 gap-3">
      <app-button
        [button_2]="true"
        [buttonClass]="'popup-button button button-danger'"
        [buttonLable]="enumButtonName.CANCEL"
        (click)="activeModal.close()"
      >
      </app-button>
      <app-button
        [button_2]="true"
        [buttonClass]="'popup-button button button-info'"
        [buttonLable]="titleName=='Edit'?'Update & Mark as Complete':titleName + ' & Mark as Complete'"
        (click)="insertUpdateToDoActivity.isMarkComplete = true;addStatusId(); addTask()"
      >
      </app-button>
      <app-button
        [button_2]="true"
        [buttonClass]="'popup-button button button-primary'"
        [buttonLable]="titleName=='Edit'?enumButtonName.UPDATE: enumButtonName.ADD"
        (click)="insertUpdateToDoActivity.isMarkComplete = false; addTask()"
        [ngClass]="isDisabled ? 'border-grey cursor-notAllowed ' : ''"
      >
      </app-button>
    </div>
  </div>
</div>
